export default __webpack_public_path__ + "static/media/2025-educatia-la-sat-1.712275ad.jpg";